export default __webpack_public_path__ + "static/media/IMG-20220728-WA0003.0d2b2274.jpg";